import { render, staticRenderFns } from "./ProjectPluginAddLocal.vue?vue&type=template&id=eadd60ec&scoped=true&"
import script from "./ProjectPluginAddLocal.vue?vue&type=script&lang=js&"
export * from "./ProjectPluginAddLocal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPluginAddLocal.vue?vue&type=style&index=0&id=eadd60ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadd60ec",
  null
  
)

export default component.exports